import { VOICE_SOURCE_DOCUMENT_SOURCES } from "core/consts";
import {
  AvailableFileRow,
  FileHISStateful,
  Filev2,
  VoiceTranscriptFile,
} from "core/types";

export function isFileHISStateful(
  file: AvailableFileRow | undefined,
): file is FileHISStateful {
  return !!(file as FileHISStateful)?.document_id;
}

export function isFileV2(file: AvailableFileRow | undefined): file is Filev2 {
  return (file as Filev2)?.category != null;
}

export function isVoiceSourceDocumentSource(
  source: string | null | undefined,
): boolean {
  return (VOICE_SOURCE_DOCUMENT_SOURCES as readonly string[]).includes(
    source ?? "",
  );
}

export function isVoiceTranscriptFile(
  file: AvailableFileRow | undefined,
): file is VoiceTranscriptFile {
  return isVoiceSourceDocumentSource((file as VoiceTranscriptFile)?.source);
}
